(() => {
  function init(root = document) {
    const collection = root.querySelector('.wm-collection');
    if (collection && !collection.dataset.ready) {
      collection.dataset.ready = 'true';
      const cards = [...collection.querySelectorAll('.wm-card')];
      const panel = collection.querySelector('.wm-filter-panel');
      const checks = [...panel.querySelectorAll('input')];
      let search = new URLSearchParams(location.search).get('q') || '';
      const sort = collection.querySelector('#wm-sort');
      function render() {
        const sizes = checks.filter(c => c.checked && c.name === 'size').map(c => c.value);
        const materials = checks.filter(c => c.checked && c.name === 'material').map(c => c.value);
        let count = 0;
        cards.forEach(card => {
          const matches = (!sizes.length || sizes.includes(card.dataset.size)) && (!materials.length || materials.includes(card.dataset.material)) && (!search || card.dataset.name.toLowerCase().includes(search.toLowerCase()));
          card.hidden = !matches;
          if (matches) count++;
        });
        collection.querySelector('.wm-result-count').textContent = `${count} ${count === 1 ? 'machine' : 'machines'}`;
        collection.querySelector('.wm-empty').hidden = count > 0;
        const active = collection.querySelector('.wm-active-filters');
        active.replaceChildren();
        checks.filter(c => c.checked).forEach(check => {
          const button = document.createElement('button');
          const label = check.name === 'size' ? `${check.value} inch` : check.value === 'wood' ? 'Wood' : 'Wood & metal';
          button.textContent = `${label} ×`;
          button.setAttribute('aria-label', `Remove ${label} filter`);
          button.addEventListener('click', () => {check.checked = false;render();});
          active.append(button);
        });
        if (search) {
          const button = document.createElement('button');
          button.textContent = `Search: ${search} ×`;
          button.setAttribute('aria-label', 'Clear search');
          button.addEventListener('click', () => {search = '';const input = document.querySelector('#wm-search');if (input) input.value = '';render();});
          active.append(button);
        }
        collection.querySelectorAll('[data-quick]').forEach(button => {
          const value = button.dataset.quick;
          const selected = value === 'all' ? !sizes.length && !materials.length : value === 'wood-metal' ? materials.length === 1 && materials[0] === value && !sizes.length : sizes.length === 1 && sizes[0] === value && !materials.length;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', selected);
        });
      }
      const close = () => {panel.classList.remove('is-open');panel.removeAttribute('role');panel.removeAttribute('aria-modal');document.body.style.overflow = '';collection.querySelector('.wm-filter-open').focus();};
      collection.querySelector('.wm-filter-open').addEventListener('click', () => {panel.classList.add('is-open');panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');document.body.style.overflow = 'hidden';panel.querySelector('.wm-filter-close').focus();});
      collection.querySelectorAll('.wm-filter-close,.wm-filter-apply').forEach(b => b.addEventListener('click', close));
      panel.addEventListener('keydown', e => {
        if (!panel.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') {
          const items = [...panel.querySelectorAll('button,input')].filter(x => x.offsetParent !== null);
          if (e.shiftKey && document.activeElement === items[0]) {e.preventDefault();items.at(-1).focus();}
          else if (!e.shiftKey && document.activeElement === items.at(-1)) {e.preventDefault();items[0].focus();}
        }
      });
      checks.forEach(c => c.addEventListener('change', render));
      collection.querySelectorAll('.wm-filter-reset').forEach(b => b.addEventListener('click', () => {checks.forEach(c => c.checked = false);search='';render();}));
      collection.querySelectorAll('[data-quick]').forEach(b => b.addEventListener('click', () => {checks.forEach(c => c.checked = c.value === b.dataset.quick);render();}));
      sort.addEventListener('change', () => {
        const sorted = [...cards].sort((a,b) => sort.value === 'size-up' ? Number(a.dataset.size)-Number(b.dataset.size) : sort.value === 'name' ? a.dataset.name.localeCompare(b.dataset.name) : cards.indexOf(a)-cards.indexOf(b));
        sorted.forEach(c => collection.querySelector('.wm-product-grid').append(c));
      });
      if (location.hash === '#wood-metal') checks.find(c => c.value === 'wood-metal').checked = true;
      window.addEventListener('hashchange', () => {if(location.hash === '#wood-metal'){checks.forEach(c=>c.checked=c.value==='wood-metal');render();}});
      const searchInput = document.querySelector('#wm-search');
      if(searchInput) searchInput.value = search;
      render();
    }
    const product = root.querySelector('.wm-product');
    if(product && !product.dataset.ready) {
      product.dataset.ready = 'true';
      const main = product.querySelector('#wm-main-photo');
      product.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
        main.src = button.dataset.photo;
        main.alt = `RIKON 10-1414 ${button.getAttribute('aria-label').toLowerCase()}`;
        product.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', b === button));
      }));
      const dialog = product.querySelector('dialog');
      product.querySelector('.wm-zoom').addEventListener('click', () => {dialog.querySelector('img').src=main.src;dialog.querySelector('img').alt=main.alt;dialog.showModal();});
      product.querySelector('.wm-lightbox-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {if(event.target === dialog) dialog.close();});
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',()=>init());
})();

(() => {
  function initCatalog(root) {
    if (root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    const preview = root.dataset.catalogMode === 'preview';
    const panel = root.querySelector('.wm-filter-panel');
    const opener = root.querySelector('.wm-filter-open');
    const closer = root.querySelector('.wm-filter-close');
    const close = () => {
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      document.body.style.overflow = '';
      opener?.focus();
    };
    opener?.addEventListener('click', () => {
      panel.classList.add('is-open');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      document.body.style.overflow = 'hidden';
      closer?.focus();
    });
    closer?.addEventListener('click', close);
    root.querySelector('.wm-filter-apply')?.addEventListener('click', close);
    panel?.addEventListener('keydown', event => {
      if (!panel.classList.contains('is-open')) return;
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      const items = [...panel.querySelectorAll('button:not(:disabled),input:not(:disabled),a[href],select')].filter(item => item.offsetParent !== null);
      if (event.shiftKey && document.activeElement === items[0]) {event.preventDefault();items.at(-1)?.focus();}
      else if (!event.shiftKey && document.activeElement === items.at(-1)) {event.preventDefault();items[0]?.focus();}
    });
    if (!preview) {
      const shortcut = [...root.querySelectorAll('a[data-quick-hash]')].find(link => link.dataset.quickHash && `#${link.dataset.quickHash}` === location.hash);
      if (!window.Shopify?.designMode) shortcut?.click();
      return;
    }
    const cards = [...root.querySelectorAll('.wm-card')];
    const promotions = [...root.querySelectorAll('[data-promo-after]')];
    function positionPromotions(filtered) {
      const grid = root.querySelector('.wm-product-grid');
      const visibleCards = [...grid.querySelectorAll('.wm-card')].filter(card => !card.hidden);
      promotions.forEach(promo => {
        promo.hidden = !visibleCards.length || (filtered && promo.dataset.promoFiltered !== 'true');
      });
      promotions.forEach(promo => promo.remove());
      const slots = new Map();
      promotions.forEach(promo => {
        const position = Math.min(Number(promo.dataset.promoAfter), visibleCards.length);
        if (!slots.has(position)) slots.set(position, []);
        slots.get(position).push(promo);
      });
      slots.forEach((items, position) => {
        const next = visibleCards[position];
        items.forEach(promo => grid.insertBefore(promo, next || null));
      });
    }
    const checks = [...root.querySelectorAll('.wm-filter-panel input[type=checkbox]')];
    const shortcuts = [...root.querySelectorAll('[data-quick-group]')];
    const active = root.querySelector('.wm-active-filters');
    let sizes = [];
    let materials = [];
    let search = new URLSearchParams(location.search).get('q') || '';
    const searchInput = document.querySelector('#wm-search');
    if (searchInput) searchInput.value = search;
    checks.forEach(input => {
      const count = cards.filter(card => card.dataset[input.name] === input.value).length;
      input.closest('label').querySelector('[data-filter-count]').textContent = count;
      input.disabled = count === 0;
    });
    function chip(label, action, accessibleLabel) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = `${label} ×`;
      button.setAttribute('aria-label', accessibleLabel || `${root.dataset.removeLabel} ${label}`);
      button.addEventListener('click', action);
      active.append(button);
    }
    function render() {
      let count = 0;
      cards.forEach(card => {
        const matches = (!sizes.length || sizes.includes(card.dataset.size)) && (!materials.length || materials.includes(card.dataset.material)) && (!search || card.dataset.name.toLowerCase().includes(search.toLowerCase()));
        card.hidden = !matches;
        if (matches) count++;
      });
      root.querySelector('.wm-result-count').textContent = `${count} ${count === 1 ? root.dataset.singular : root.dataset.plural}`;
      root.querySelector('.wm-empty').hidden = count > 0;
      positionPromotions(Boolean(sizes.length || materials.length || search));
      checks.forEach(input => {input.checked = (input.name === 'size' ? sizes : materials).includes(input.value);});
      active.replaceChildren();
      for (const [group, values] of [['size', sizes], ['material', materials]]) {
        values.forEach(value => {
          const input = checks.find(item => item.name === group && item.value === value);
          const shortcut = shortcuts.find(item => item.dataset.quickGroup === group && item.dataset.quickValue === value);
          const label = input?.dataset.filterLabel || shortcut?.textContent.trim() || value;
          chip(label, () => {if (group === 'size') sizes = sizes.filter(item => item !== value);else materials = materials.filter(item => item !== value);render();});
        });
      }
      if (search) chip(`${root.dataset.searchLabel}: ${search}`, () => {search = '';if (searchInput) searchInput.value = '';render();}, root.dataset.clearSearch);
      shortcuts.forEach(button => {
        const group = button.dataset.quickGroup;
        const value = button.dataset.quickValue;
        const selected = group === 'all' ? !sizes.length && !materials.length && !search : group === 'size' ? sizes.length === 1 && sizes[0] === value && !materials.length : materials.length === 1 && materials[0] === value && !sizes.length;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected);
      });
    }
    checks.forEach(input => input.addEventListener('change', () => {
      sizes = checks.filter(item => item.checked && item.name === 'size').map(item => item.value);
      materials = checks.filter(item => item.checked && item.name === 'material').map(item => item.value);
      render();
    }));
    root.querySelectorAll('.wm-filter-reset').forEach(button => button.addEventListener('click', () => {sizes = [];materials = [];search = '';if (searchInput) searchInput.value = '';render();}));
    shortcuts.forEach(button => button.addEventListener('click', () => {
      sizes = button.dataset.quickGroup === 'size' ? [button.dataset.quickValue] : [];
      materials = button.dataset.quickGroup === 'material' ? [button.dataset.quickValue] : [];
      search = '';
      if (searchInput) searchInput.value = '';
      render();
    }));
    root.querySelector('.wm-catalog-sort')?.addEventListener('change', event => {
      const order = event.target.value;
      const sorted = [...cards].sort((a,b) => order === 'size-up' ? Number(a.dataset.size)-Number(b.dataset.size) : order === 'name' ? a.dataset.name.localeCompare(b.dataset.name) : cards.indexOf(a)-cards.indexOf(b));
      sorted.forEach(card => root.querySelector('.wm-product-grid').append(card));
      positionPromotions(Boolean(sizes.length || materials.length || search));
    });
    render();
    const shortcut = shortcuts.find(button => button.dataset.quickHash && `#${button.dataset.quickHash}` === location.hash);
    shortcut?.click();
  }
  function init() {document.querySelectorAll('.wm-editable-collection').forEach(initCatalog);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {if (event.target.querySelector('.wm-editable-collection .is-open')) document.body.style.overflow = '';});
  window.addEventListener('hashchange', () => {document.querySelectorAll('.wm-editable-collection [data-quick-hash]').forEach(button => {if (button.dataset.quickHash && `#${button.dataset.quickHash}` === location.hash) button.click();});});
})();


/* ToolShop subscription widget labels and display prices. */
(() => {
  const observed = new WeakSet();
  let scheduled = false;
  const productObservers = new Map();

  function update() {
    scheduled = false;
    document.querySelectorAll('.product__info-container').forEach(product => {
      const cards = product.querySelectorAll('.toggle_card');
      if (!cards.length) return;
      cards.forEach(card => {
        if (card.querySelector('[data-radio-type="selling_plan"]:checked')) {
          const subscriptionTab = card.querySelector('.tab_radio[id^="tab_subscribe_"]');
          if (subscriptionTab && !subscriptionTab.checked) subscriptionTab.checked = true;
        }
        const label = card.querySelector('.tab_label[for^="tab_otp_"] > span:first-child');
        if (label) {
          const fullLabel = label.dataset.wmFullLabel || label.textContent;
          label.dataset.wmFullLabel = fullLabel;
          const text = card.clientWidth <= 400 ? fullLabel.replace(/\s+purchase\b/i, '') : fullLabel;
          if (label.textContent !== text) label.textContent = text;
        }
        if (!observed.has(card)) {
          observed.add(card);
          resizeObserver.observe(card);
        }
      });
      product.querySelectorAll('.price').forEach(price => {
        const walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          const text = node.nodeValue.replace(/\s+USD\b/g, '');
          if (node.nodeValue !== text) node.nodeValue = text;
        }
      });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  const resizeObserver = new ResizeObserver(schedule);
  function start() {
    productObservers.forEach((observer, product) => {
      if (!product.isConnected) {
        observer.disconnect();
        product.querySelectorAll('.toggle_card').forEach(card => {
          resizeObserver.unobserve(card);
          observed.delete(card);
        });
        productObservers.delete(product);
      }
    });
    const products = document.querySelectorAll('.product__info-container');
    products.forEach(product => {
      if (productObservers.has(product)) return;
      const observer = new MutationObserver(schedule);
      observer.observe(product, { childList: true, subtree: true, characterData: true });
      productObservers.set(product, observer);
    });
    if (products.length) schedule();
  }
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', start);
  document.addEventListener('wm:variant-content:updated', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
